<div *ngIf="product" class="product-item text-center mt-3 mb-3">
  <div class="series-label" *ngIf="productSpecificationAttribute(product, 'series')">
    <span [innerHtml]="productSpecificationAttribute(product, 'series') | safeHtml"></span>
  </div>
  <a (click)="productClick(product)" class="image-link">
    <div class="aspect-ratio-box">
      <div class="aspect-ratio-box-inside">
        <picture>
          <source [attr.defaultImage]="settings?.holdingImage?.small" [attr.lazyLoad]="product.images[0]?.small + '.webp'" type="image/webp" />
          <img [defaultImage]="settings?.holdingImage?.small + '?productId=' + product.id" (onStateChange)="imageStateChange($event, product)" [lazyLoad]="product.images[0]?.small" [alt]="product.name">
        </picture>
      </div>
    </div>
  </a>
  <div class="d-flex flex-row flex-wrap justify-content-start prices" style="position: relative;">
    <div class="flex-100 controls">
      <div class="name-price">
        <div class="d-flex flex-row flex-wrap justify-content-start" style="position: relative;">
          <div class="flex-100">
            <div class="name">
              <a [routerLink]="[product.seName]" (click)="productClick(product)" [routerLink]="[product.seName]" class="title">{{product.name}}</a>
            </div>
          </div>
          <div class="flex-100" style="position: relative;">
                  <div class="d-flex flex-row flex-wrap justify-content-center price pt-1 pb-1 pl-1 pr-1">
              <div *ngIf="settings?.showPrice(product)">
                <div *ngIf="product.oldPrice" class="old-price text-muted"><span>${{product.oldPrice | number : '1.2-2'}}</span></div>
                <div class="new-price">${{product.newPrice | number : '1.2-2'}}</div>
                <div class="d-none d-md-block">
                  <app-rating [product]="product" [direction]="'column'"></app-rating>
                </div>
              </div>
            </div>
            <div class="d-md-none ratings-container">
              <app-rating [product]="product" [direction]="'column'"></app-rating>
            </div>
          </div>
          <div class="flex-100 buttons">
            <app-controls-list [productSimple]="product" listId="content" (onOpenProductDialog)="openProductDialog(product)"></app-controls-list>
          </div>
        </div>
      </div>
    </div>
  </div>
